export enum PartnerRegStatus {
  NOT_APPLICABLE = 'NOT_APPLICABLE', // 파트너 센터 대상이 아닌 경우 (실제 해당 케이스는 내려오지 않음)
  NEED_SVC_REG = 'NEED_SVC_REG', // 등록된 요청기관이 없는 경우 (FE에서는 별도로 처리하지 않아도 되는 경우)
  COMPLETE = 'COMPLETE',
  NEED_APP_REG = 'NEED_APP_REG',
  NEED_INFO_REG = 'NEED_INFO_REG'
}

/**
 * MY BIZ 목록에서 상태 뱃지로 노출할 문구.
 * 문구가 정의되지 않은 상태(NEED_SVC_REG 등)는 뱃지를 노출하지 않는다.
 */
export const PARTNER_REG_STATUS_BADGE = {
  [PartnerRegStatus.NEED_APP_REG]: '정보 등록 필요',
  [PartnerRegStatus.NEED_INFO_REG]: '정보 등록 필요'
} as const satisfies Partial<Record<PartnerRegStatus, string>>;

export type BadgedPartnerRegStatus = keyof typeof PARTNER_REG_STATUS_BADGE;

export const isBadgedPartnerRegStatus = (status?: PartnerRegStatus): status is BadgedPartnerRegStatus =>
  !!status && status in PARTNER_REG_STATUS_BADGE;
